const oneDay = 24 * 3600 * 1000
const isSameDay = (start: Date, end: Date) =>
  Math.abs(start.getTime() - end.getTime()) < oneDay && start.getDate() === end.getDate()

export default isSameDay
